import {getFromLS} from '@common/service/CommonService';
import {Div, EgdLogo, useMatches} from '@eon.cz/apollo13-frontend-common';
import {styled} from '@mui/material/styles';
import {ReactNode} from 'react';

import theme from 'theme';

export const getDeviceType = () => {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    const uaNew = typeof navigator !== 'undefined' ? navigator.userAgentData : undefined;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return 'tablet';
    }
    if (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua) || uaNew?.mobile) {
        return 'mobile';
    }
    return 'desktop';
};

const DivWrapper = styled('div')(({theme}) => ({
    backgroundColor: theme.palette.secondary.main,
    height: '100dvh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}));
const DivChildren = styled('div')(() => ({
    width: 'auto',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    overflowY: 'auto',
}));

type Props = {
    children: ReactNode;
};

/**
 * Wrapper komponenta obsahující pozadí aplikace
 */
export const LandingBackground = ({children}: Props) => {
    const isMobile = getFromLS('mobile').isMobile;
    const matches = useMatches();
    return (
        <DivWrapper>
            <DivChildren role="main">
                <Div sx={{display: 'flex', justifyContent: 'center'}}>
                    <EgdLogo width={isMobile || matches ? 90 : 120} height={isMobile || matches ? 50 : 100} pathFill={theme.palette.error.main} />
                </Div>

                {children}
            </DivChildren>
        </DivWrapper>
    );
};
